import React from 'react';

const Button = React.forwardRef(({ 
  className = '', 
  variant = 'default', 
  size = 'default', 
  children,
  ...props 
}, ref) => {
  const baseClasses = "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  
  const variantClasses = {
    // Solar-gold primary: gold gradient, dark ink (never white — fails contrast), electric glow.
    default: "bg-solar-gradient text-[#1a1200] shadow-glow hover:shadow-cta-hover hover:brightness-[1.06]",
    destructive: "bg-off-strong dark:bg-off text-white hover:opacity-90",
    outline: "border border-gray-300 dark:border-surface-dark-border bg-transparent text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-surface-dark-raised",
    secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 dark:bg-surface-dark-raised dark:text-gray-100 dark:hover:bg-surface-dark-border",
    ghost: "bg-transparent text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-surface-dark-raised",
    link: "underline-offset-4 hover:underline text-primary-700 dark:text-primary-400",
  };
  
  const sizeClasses = {
    default: "h-10 py-2 px-4",
    sm: "h-9 px-3 rounded-md",
    lg: "h-11 px-8 rounded-md",
    icon: "h-10 w-10",
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button
      className={classes}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

Button.displayName = "Button";

export { Button };
